<script>
    import {onMount} from "svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import {_} from '../lib/i18n';

    export let currentView;
    export let analyze;

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let showNavButtons = true;

    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    let authRequired;
    $: authRequired = (analyze ? (analyze.is_private && (!analyze.handler || analyze.is_not_friend)) : false);

    let loaded = false;
    let topicSlider;

    const categories = [
        {
            slide: 0,
            id: 'likes',
            title: $_('analyzeControl.likesCategoryTitle'),
            icon: '/spy20-lk/icons/likes.svg',
            prevItem: 'comments',
            nextItem: 'follows',
        },
        {
            slide: 1,
            id: 'follows',
            title: $_('analyzeControl.followsCategoryTitle'),
            icon: '/spy20-lk/icons/follows.svg',
            prevItem: 'likes',
            nextItem: 'followers',
        },
        {
            slide: 2,
            id: 'followers',
            title: $_('analyzeControl.followersCategoryTitle'),
            icon: '/spy20-lk/icons/followers.svg',
            prevItem: 'follows',
            nextItem: 'likers',
        },
        {
            slide: 3,
            id: 'likers',
            title: $_('analyzeControl.likersCategoryTitle'),
            icon: '/spy20-lk/icons/likers.svg',
            prevItem: 'followers',
            nextItem: 'stories',
        },
        {
            slide: 4,
            id: 'stories',
            title: $_('analyzeControl.storiesCategoryTitle'),
            icon: '/spy20-lk/icons/stories.svg',
            prevItem: 'likers',
            nextItem: 'posts_and_reels',
        },
        {
            slide: 5,
            id: 'posts_and_reels',
            title: $_('analyzeControl.postsAndReelsCategoryTitle'),
            icon: '/spy20-lk/icons/posts.svg',
            prevItem: 'stories',
            nextItem: 'comments',
        },
        {
            slide: 6,
            id: 'comments',
            title: $_('analyzeControl.commentsCategoryTitle'),
            icon: '/spy20-lk/icons/comments.svg',
            prevItem: 'posts_and_reels',
            nextItem: 'likes',
        }
    ];

    function getCategory(id) {
        return categories[categories.findIndex(item => item.id == id)];
    }

    export let startingSlide = 0;
    export let currentSlide = 0;
    let currentCategory;
    $: (currentSlide || !currentSlide) && (currentCategory = categories[currentSlide]) && (currentView = currentCategory.id);
    let prevCategory;
    $: currentCategory && (prevCategory = categories[categories.findIndex(item => item.id == currentCategory.prevItem)]);
    let nextCategory;
    $: currentCategory && (nextCategory = categories[categories.findIndex(item => item.id == currentCategory.nextItem)]);


    onMount(() => {
        loaded = true;

        console.log(params);
        if (params.lastRoute) {
            startingSlide = categories[categories.findIndex(item => item.id === params.lastRoute)].slide;
            currentSlide = categories[categories.findIndex(item => item.id === params.lastRoute)].slide;
        }

        try {
            topicSlider = new Swiper('.topic-block__slider-wrapper', {
                slidesPerView: "auto",
                centeredSlides: true,
                slideActiveClass: 'active',
                slideToClickedSlide: true,
                loop: true,
                initialSlide: startingSlide,
            });
            topicSlider.on('slideChange', function () {
                currentSlide = topicSlider.realIndex;
            });
            window.topicSlider = topicSlider;
        } catch (err) { console.error(err) }

    });

    let progress;
    $: progress = (analyze && analyze.progress ? analyze.progress : {});

    function nextSlide() {
        topicSlider.slideNext();
    }

    function prevSlide() {
        const prevId = topicSlider.realIndex > 0 ? topicSlider.realIndex - 1 : 6;
        topicSlider.slideToLoop(prevId);
    }
</script>

<section class="topic-block">
    <div class="topic-block__title" >{$_('analyzeControl.categoriesListTitle')}:</div>
    <div class="topic-block__slider-wrapper swiper">
        <div class="topic-block__wrapper swiper-wrapper">
            {#if true}
            {#each categories as category (category.id)}
            <div class={`topic-block__item swiper-slide ${(
                isTemporary ||
                (!isTemporary && category.id === 'follows' && analyze && analyze.likesProgress != 100) ||
                (!isTemporary && category.id === 'followers' && analyze && analyze.listProgress != 100) ||
                (!isTemporary && category.id === 'likers' && analyze && analyze.fansProgress != 100) ||
                (!isTemporary && category.id === 'stories' && analyze && analyze.storiesProgress != 100) ||
                (!isTemporary && category.id === 'posts_and_reels' && analyze && analyze.postsProgress != 100) ||
                (!isTemporary && category.id === 'likes' && analyze && analyze.likesProgress != 100) ||
                (!isTemporary && category.id === 'comments' && analyze && analyze.commentsProgress != 100)
             ) ? 'disabled' : ''}`}>
                <div class="topic-block__item-icon">
                    {#if category.id === 'follows'}
                        {#if !authRequired && !isTemporary && analyze && analyze.likesProgress != 100}
                            <LoadingIcon show={true} height="16" width="16" />
                        {:else}
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.6673 15.5L13.334 17.1667L18.334 12.1667M3.33398 17.1667V16.3333C3.33398 14.0321 5.19946 12.1667 7.50065 12.1667H10.6257M12.5007 6.33333C12.5007 8.17428 11.0083 9.66667 9.16732 9.66667C7.32637 9.66667 5.83398 8.17428 5.83398 6.33333C5.83398 4.49238 7.32637 3 9.16732 3C11.0083 3 12.5007 4.49238 12.5007 6.33333Z" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        {/if}
                    {/if}
                    {#if category.id === 'followers'}
                        {#if !authRequired && !isTemporary && analyze && analyze.listProgress != 100}
                            <LoadingIcon show={true} height="16" width="16" />
                        {:else}
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.33398 17.1667V16.3333C3.33398 14.0321 5.19946 12.1667 7.50065 12.1667H10.6257M14.6136 12.1371V15.0833M14.6136 15.0833V18.0296M14.6136 15.0833H17.5599M14.6136 15.0833H11.6673M12.5007 6.33333C12.5007 8.17428 11.0083 9.66667 9.16732 9.66667C7.32637 9.66667 5.83398 8.17428 5.83398 6.33333C5.83398 4.49238 7.32637 3 9.16732 3C11.0083 3 12.5007 4.49238 12.5007 6.33333Z" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        {/if}
                    {/if}
                    {#if category.id === 'likers'}
                        {#if !authRequired && !isTemporary && analyze && analyze.fansProgress != 100}
                            <LoadingIcon show={true} height="16" width="16" />
                        {:else}
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 16.3333V15.5C2.5 13.659 3.99238 12.1667 5.83333 12.1667H9.16667C11.0076 12.1667 12.5 13.659 12.5 15.5V16.3333M12.5 9.66666C13.8807 9.66666 15 8.54737 15 7.16666C15 5.78594 13.8807 4.66666 12.5 4.66666M17.5 16.3333V15.5C17.5 13.659 16.0076 12.1667 14.1667 12.1667H13.75M10 7.16666C10 8.54737 8.88071 9.66666 7.5 9.66666C6.11929 9.66666 5 8.54737 5 7.16666C5 5.78594 6.11929 4.66666 7.5 4.66666C8.88071 4.66666 10 5.78594 10 7.16666Z" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        {/if}
                    {/if}
                    {#if category.id === 'stories'}
                        {#if !authRequired && !isTemporary && analyze && analyze.storiesProgress != 100}
                            <LoadingIcon show={true} height="16" width="16" />
                        {:else}
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 6C2.5 4.34315 3.84315 3 5.5 3H11.1667C12.8235 3 14.1667 4.34315 14.1667 6V11.6667C14.1667 13.3235 12.8235 14.6667 11.1667 14.6667H5.5C3.84315 14.6667 2.5 13.3235 2.5 11.6667V6Z" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M17.5007 6.33334V15C17.5007 16.6569 16.1575 18 14.5007 18H5.83398" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M7.5 10.5V7.16666L10.119 8.83332L7.5 10.5Z" fill="#161516" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        {/if}
                    {/if}
                    {#if category.id === 'posts_and_reels'}
                        {#if !authRequired && !isTemporary && analyze && analyze.postsProgress != 100}
                            <LoadingIcon show={true} height="16" width="16" />
                        {:else}
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3.33398" y="3.83334" width="13.3333" height="13.3333" rx="3" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect>
                                <path d="M3.33398 13.8333L6.79354 10.3737C7.18407 9.98321 7.81723 9.98321 8.20776 10.3737L10.834 13M10.834 13L13.0436 10.7904C13.4341 10.3999 14.0673 10.3999 14.4578 10.7904L16.6673 13M10.834 13L12.709 14.875" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        {/if}
                    {/if}
                    {#if category.id === 'likes'}
                        {#if !authRequired && !isTemporary && analyze && analyze.likesProgress != 100}
                            <LoadingIcon show={true} height="16" width="16" />
                        {:else}
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.68835 10.7595L10 17.0712L16.3116 10.7595C17.8961 9.17508 17.8961 6.60615 16.3116 5.02169C14.7272 3.43722 12.1583 3.43722 10.5738 5.02169L10 5.59547L9.42621 5.02169C7.84175 3.43722 5.27282 3.43722 3.68835 5.02169C2.10388 6.60615 2.10388 9.17508 3.68835 10.7595Z" stroke="#161516" stroke-width="1.5" stroke-linejoin="round"></path>
                            </svg>
                        {/if}
                    {/if}
                    {#if category.id === 'comments'}
                        {#if !authRequired && !isTemporary && analyze && analyze.commentsProgress != 100}
                            <LoadingIcon show={true} height="16" width="16" />
                        {:else}
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 6.33333C2.5 4.49238 3.99238 3 5.83333 3H14.1667C16.0076 3 17.5 4.49238 17.5 6.33333V13C17.5 14.8409 16.0076 16.3333 14.1667 16.3333H11.875L10.6667 17.9444C10.3333 18.3889 9.66667 18.3889 9.33333 17.9444L8.125 16.3333H5.83333C3.99238 16.3333 2.5 14.8409 2.5 13V6.33333Z" stroke="#161516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        {/if}
                    {/if}
                </div>
                <div class="topic-block__item-title">{category.title}</div>
            </div>
            {/each}
            {/if}

        </div>
    </div>
</section>

<div class="feed-content">
    <slot name="inner"></slot>

    {#if showNavButtons}
    <section class="feed-footer">
        <div class="feed-footer__item feed-footer__item_prev">
            <p class="feed-footer__subtitle">{$_('analyzeControl.previousCategoryLabel')}</p>
            <h4 class="feed-footer__title-btn"
                on:click={prevSlide}
            >{prevCategory.title}</h4>
        </div>
        <div class="feed-footer__item feed-footer__item_next">
            <p class="feed-footer__subtitle">{$_('analyzeControl.nextCategoryLabel')}</p>
            <h4 class="feed-footer__title-btn"
                on:click={nextSlide}
            >{nextCategory.title}</h4>
        </div>
    </section>
    {/if}
</div>


<style>
    .topic-block__item {
        display: flex;
    }
</style>